export const HOST = ['https://test-customer.ihuhoo.com/infobase', 'https://customer.tradeup.com/infobase'];

export const API = {
    // RD: @renjianjun https://apidocs.tigerfintech.com/repository/21/api/master/WEB%20API.json#/operations/get-api-v1-static-field
    fundBankCountryList: '/api/v1/static/field/funding_bankcountry'
};

export function bindCG() {
    const cfg = CG_API.customerInfobase?.COMMON;

    if (cfg) {
        HOST.fill(cfg);
    }
}
